// React
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// MUI
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

// Assets
import visiable from "../../assets/visiable.svg";

// Styles
import "./PublishIndia.scss";

// Components
import PublishIndiaFormDialog from "./PublishIndiaFormDialog";
import PublishIndiaPdf from "../PublishIndiaPDF/PublishIndiaPdf";
import Spinner from "../spinner/Spinner";

// Services
import { logout } from "../../services/IndiaService";
import { getStorageItemLocal } from "../../services/storageServices";

// Utils / Local Modules
import {
  AdminEntry,
  defaultAdminEntry,
  prepareAdminEntryForEdit,
} from "../../services/PublishIndiaService";

// Config
import { appConfig } from "../../config/appConfig";

interface Catgry {
  id: number;
  name: string;
}

interface PublishIndiaFormDialogProps {
  setIndiaCount: any;
  visible: boolean;
  setIndiaPDFCount: any;
}
const PublishIndia: React.FC<PublishIndiaFormDialogProps> = ({
  setIndiaCount,
  visible,
  setIndiaPDFCount,
}) => {
  const [dataList, setDataList] = useState<AdminEntry[]>([]);
  const [filterList, setFilterList] = useState<AdminEntry[]>([]);
  const [filterCategory, setfilterCategory] = useState<string | null>(null);

  const [loading, setLoading] = useState(false);

  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [showForm, setShowForm] = useState(false);

  const [categories, setCategories] = useState<Catgry[]>([]);
  const [formData, setFormData] = useState<AdminEntry>(defaultAdminEntry);

  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const rowsPerPage = 20;

  useEffect(() => {
    const filteredData = filterList.filter((item) => {
      const matchesCategory =
        !filterCategory ||
        (item.category || "")
          .trim()
          .toLowerCase()
          .includes(filterCategory.trim().toLowerCase());

      const isPending = item.status === "Pending";

      return matchesCategory && isPending;
    });
    setIndiaCount(filteredData.length);
    setDataList(filteredData);
  }, [filterList, filterCategory]);

  useEffect(() => {
    const savedData = localStorage.getItem("adminDataList");
    if (savedData) {
      const parsedData: AdminEntry[] = JSON.parse(savedData);

      setFilterList(parsedData);

      if (!savedData || parsedData.length === 0) {
        setEditingIndex(null);
      }
    }
  }, []);

  //Fetch Categories and states

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const tokenString = getStorageItemLocal("token");
        const token = tokenString ? JSON.parse(tokenString) : null;
        const response = await fetch(
          `${appConfig.serviceUrls.getAdminEntries}/categories`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch categories");
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories", error);
      }
    };

    //call the fetch functions
    fetchCategories();
  }, []);
  const fetchData = async () => {
    setLoading(true);
    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;
      const response = await fetch(appConfig.serviceUrls.saveIndiaEntries, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 401) {
        logout(navigate);
        <Button onClick={() => logout(navigate)}>Logout</Button>;
        return;
      }
      if (!response.ok) throw new Error("Failed to fetch data");
      const data: AdminEntry[] = await response.json();

      setFilterList(data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (editingIndex !== null) {
      const selectedEntry = dataList.find((item) => item.id === editingIndex);
      if (selectedEntry) {
        const imageUrls =
          typeof selectedEntry.imageUrls === "string"
            ? selectedEntry.imageUrls.split(",")
            : Array.isArray(selectedEntry.imageUrls)
            ? selectedEntry.imageUrls
            : [];

        const videoUrls =
          typeof selectedEntry.videoUrls === "string"
            ? selectedEntry.videoUrls.split(",")
            : Array.isArray(selectedEntry.videoUrls)
            ? selectedEntry.videoUrls
            : [];

        setFormData({
          ...selectedEntry,
          imageUrls,
          videoUrls,
        });
      }
    }
  }, [editingIndex, dataList]);

  const resetForm = () => {
    setFormData({
      ...defaultAdminEntry,
      id: dataList.length + 1, // Ensure a new ID
      lastUpdated: new Date().toISOString(), // Update timestamp
    });
    setEditingIndex(null);
  };
  // handle Approve
  const handleApprove = async (index: number) => {
    if (!window.confirm("Are you sure want to approve & publish this entry?"))
      return;
    await handlePublish(index, "Published", "3");
  };
  // handle Approve
  const handleReject = async (index: number) => {
    if (!window.confirm("Are you sure want to reject this entry?")) return;
    await handlePublish(index, "Rejected", "2");
  };

  //handle publish
  const handlePublish = async (
    index: number,
    stat: string,
    statcode: string
  ) => {
    // if (!window.confirm("Are you sure want to publish this entry?")) return;

    const selectedEntry = dataList[index];
    if (!selectedEntry) {
      console.error("No entry found at index:", index);
      return;
    }
    setLoading(true);
    const formDataToSend = new FormData();

    const appendBasic = (key: string, value: any) => {
      if (value !== undefined && value !== null)
        formDataToSend.append(key, String(value));
    };

    // Basic fields
    appendBasic("id", selectedEntry.id);
    appendBasic("category", selectedEntry.category);
    appendBasic("subcategory", selectedEntry.subCategory);
    appendBasic("description", selectedEntry.description);
    appendBasic("description2", selectedEntry.description2);
    appendBasic("description3", selectedEntry.description3);
    appendBasic("pdfIsActive", selectedEntry.pdfIsActive);
    appendBasic("pdfName", selectedEntry.pdfName);
    appendBasic("pdfIsActive2", selectedEntry.pdfIsActive2);
    appendBasic("pdfName2", selectedEntry.pdfName2);
    appendBasic("pdfIsActive3", selectedEntry.pdfIsActive3);
    appendBasic("pdfName3", selectedEntry.pdfName3);
    appendBasic("isActive", selectedEntry.isActive);
    appendBasic("uploadBy", selectedEntry.uploadBy);
    // appendBasic("approveBy", selectedEntry.approveBy);
    const username = getStorageItemLocal("username") ?? "";
    formDataToSend.append("publishBy", username);
    formDataToSend.append("approveBy", username);
    appendBasic("status", stat); // override
    appendBasic("statusCode", statcode);

    // Grid fields (loop 1–9)
    for (let i = 1; i <= 9; i++) {
      const key = `gridType${i}` as keyof AdminEntry;
      appendBasic(key, selectedEntry[key]);

      const key1 = `gridIconName${i}` as keyof AdminEntry;
      appendBasic(key1, selectedEntry[key1]);

      const key2 = `grid${i}` as keyof AdminEntry;
      appendBasic(key2, selectedEntry[key2]);

      const key3 = `gridThumbnail${i}` as keyof AdminEntry;
      appendBasic(key3, selectedEntry[key3]);
    }

    const url = `${appConfig.serviceUrls.saveIndiaEntries}/${selectedEntry.id}`;

    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;
      const response = await fetch(url, {
        method: "PUT",
        body: formDataToSend,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 401) {
        logout(navigate);
        <Button onClick={() => logout(navigate)}>Logout</Button>;
        return;
      }
      if (!response.ok) throw new Error("Failed to save data");

      alert(`Data ${stat} successfully`);
      fetchData();
      resetForm();
      setEditingIndex(null);
    } catch (error) {
      console.error("Error publishing data:", error);
      alert("Network Error");
    } finally {
      setLoading(false);
    }
  };

  // handle view
  const handleView = (index: number) => {
    if (!dataList || !Array.isArray(dataList) || dataList.length === 0) {
      console.error("Error: dataList is empty");
      return;
    }

    const selectedEntry = dataList[index];
    if (!selectedEntry) {
      console.error("No entry found at index:", index);
      return;
    }

    const preparedEntry = prepareAdminEntryForEdit(selectedEntry);

    setFormData(preparedEntry);
    setEditingIndex(-1);
    setShowForm(true);
  };

  if (!visible) return null;
  return (
    <>
      <PublishIndiaPdf setIndiaPDFCount={setIndiaPDFCount} visible={visible} />
      <Box sx={{ marginBottom: "5px !important" }} />
      {loading ? (
        <>
          {" "}
          <Spinner></Spinner>
        </>
      ) : (
        <TableContainer component={Paper} sx={{ width: "100%" }}>
          {dataList?.length > 0 ? (
            <Table size="small">
              <TableHead>
                <TableRow className="custom-table-head-row">
                  <TableCell>
                    <b>Request ID</b>
                  </TableCell>
                  <TableCell>
                    <b></b>
                  </TableCell>
                  <TableCell>
                    <b>Category</b>
                  </TableCell>
                  <TableCell>
                    <b></b>
                  </TableCell>
                  <TableCell>
                    <b>Media /Text / PDF</b>
                  </TableCell>

                  <TableCell>
                    <b></b>
                  </TableCell>
                  <TableCell className="nowrap">
                    <b>Status</b>
                  </TableCell>
                  <TableCell>
                    <b></b>
                  </TableCell>

                  <TableCell>
                    <b>Actions</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataList
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <TableRow key={index} className="custom-table-row">
                      <TableCell className="nowrap">
                        MAP-{item.id || "\u00A0"}
                      </TableCell>
                      <TableCell>
                        <b></b>
                      </TableCell>
                      <TableCell className="nowrap">
                        {item.categoryName || "\u00A0"}
                      </TableCell>
                      <TableCell>
                        <b></b>
                      </TableCell>
                      <TableCell className="common-txt nowrap">
                        <Box className="description-wraper">
                          <Typography className="description-txt">
                            {" "}
                            View
                          </Typography>{" "}
                          <IconButton
                            color="primary"
                            size="small"
                            onClick={() => {
                              handleView(page * rowsPerPage + index);
                            }}
                          >
                            <img
                              src={visiable}
                              alt="visible"
                              className="img-style"
                            />
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <b></b>
                      </TableCell>

                      {item.status === "Approved" ? (
                        <TableCell className="approved-text">
                          {item.status}
                        </TableCell>
                      ) : item.status === "Published" ? (
                        <TableCell className="publish-txt">
                          {item.status}
                        </TableCell>
                      ) : item.status === "Pending" ? (
                        <TableCell className="pending-txt">
                          {item.status}
                        </TableCell>
                      ) : (
                        <TableCell>{item.status}</TableCell>
                      )}
                      <TableCell>
                        <b></b>
                      </TableCell>

                      <TableCell align="left" className="nowrap display-btn">
                        <IconButton
                          className="reject-box"
                          size="small"
                          onClick={() => {
                            handleReject(page * rowsPerPage + index);
                          }}
                        >
                          <Typography className="box-text">Reject</Typography>
                        </IconButton>

                        <IconButton
                          className="approve-box"
                          size="small"
                          onClick={() => {
                            handleApprove(page * rowsPerPage + index);
                          }}
                        >
                          <Typography className="box-text">
                            Approve & Publish
                          </Typography>
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          ) : (
            <></>
          )}
        </TableContainer>
      )}

      <PublishIndiaFormDialog
        open={showForm}
        // onClose={handleCloseDialog}
        fetchData={fetchData}
        resetForm={resetForm}
        categories={categories}
        formData={formData}
        setFormData={setFormData}
        editingIndex={editingIndex}
        setEditingIndex={setEditingIndex}
        setShowForm={setShowForm}
        dataList={dataList}
      />
    </>
  );
};

export default PublishIndia;
